import LoadingPage from "components/Fallback/LoadingPage";
import { useAuthStore } from "stores/auth.store";

/**
 * Holds the app behind a loader until Firebase has restored (or ruled out) the
 * persisted session.
 */
const FirebaseWrapper = ({ children }) => {
  const { isReady } = useAuthStore();

  if (!isReady) {
    return <LoadingPage />;
  }

  return children;
};

export default FirebaseWrapper;
